// 初期表示
export const PAGE_INIT = "corp/telecom/search/PAGE_INIT";
// データ初期化
export const DATA_CLEAR = "corp/telecom/search/DATA_CLEAR";
